import React from "react";
import TopNavbar from "../../components/topNavbar/TopNavbar";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import PidLegend from "../../components/pidLegend/pidLegend";
import { PageLinkApp, PageModalApp } from "../../components/PageApps/PageApps";
import PageCarousel from "../../components/Carousel/Carousel";
import PageHeader from "../pageHeader/PageHeader";
import SupplierZoneSummary from "../../components/PageApps/SupplierZoneSummary";
import EngineeringPageSummary from "../../components/PageApps/EngineeringPageSummary";

class EngineeringPage extends React.Component {
  constructor(props) {
    super(props);

    document.body.classList.add("project-viewer");
  }

  render() {
    return (
      <div style={{ overflowY: "auto" }}>
        <Div100vh>
          <TopNavbar />
          <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader>
          <EngineeringPageSummary />
          <br />
          <br />
          <div style={{ textAlign: "center" }}>
            <h1 style={{ fontWeight: "bold" }}>Engineering Apps</h1>
          </div>
          <section className="container develop-content pt-5" id="content">
            <div className="row">
              <PageModalApp
                dataTarget="#PID"
                src="/PIDLegend.gif"
                title="P&ID Legend"
              />
              <PidLegend />
              <PageLinkApp
                linkTo="/SketchUp"
                title="Sketchup Tool"
                src="/PIDSketch.gif"
                id="PIDsketch"
              />
              <PageLinkApp
                linkTo="/dsear"
                title="DSEAR Register"
                src="/DSEAR.gif"
                id="DSEARRegister"
              />
            </div>

            <div className="row"></div>
          </section>
        </Div100vh>
      </div>
    );
  }
}

export default connect()(EngineeringPage);
